<template>
	<div class="shop-car-page">
		<!-- 页面头部（导航栏 + 面包屑） -->
		<newsPageHeader :gtype="0" />
		
		<!-- ====== 页面标题 ====== -->
		<div class="page-title animate__animated animate__fadeIn">
			<el-image class="page-title-icon" :src="require('@/static/CodeBuddyAssets/30845_2685/56.svg')"></el-image>
			<h2 class="page-title-text">购物车</h2>
			<span class="page-title-count">({{ cartNub }})</span>
		</div>

		<!-- ====== 购物车主体 ====== -->
		<div class="car-card animate__animated animate__fadeInUp">
			<!-- 工具栏 -->
			<div class="car-toolbar">
				<div class="toolbar-left">
					<el-image class="tb-check-icon" :src="selAll ? require('@/static/CodeBuddyAssets/30845_2685/17.svg') : require('@/static/CodeBuddyAssets/30845_2685/48.svg')" @click="carSelAll"></el-image>
					<span class="tb-all-text" @click="carSelAll">全选</span>
				</div>
				<div class="toolbar-right">
					<!-- <div class="tb-action-btn tb-fav-btn" @click="deleteSelected">
						<span>删除</span>
					</div> -->
					<!-- <div class="tb-action-btn tb-fav-btn">
						<span>移入收藏</span>
					</div> -->
				</div>
			</div>

			<!-- 暂无 -->
			<div class="zwBox" v-if="!carArr.length">
				<el-image :src="require('@/static/zw.svg')"></el-image>
				<p>暂无相关数据...</p>
			</div>
			
			<!-- 列表 -->
			<div class="store-group" v-for="(store, sIdx) in carArr" :key="sIdx">
				<div class="store-header">
					<el-image class="store-checkbox" @click="selStore(store.storeAll,store.merchantName)" :src="store.storeAll ? require('@/static/CodeBuddyAssets/30845_2685/16.svg') : require('@/static/CodeBuddyAssets/30845_2685/27.svg')"></el-image>
					<el-image class="store-avatar" :src="require('@/static/CodeBuddyAssets/30845_2685/14.svg')"></el-image>
					<span class="store-tag-text tag-blue" v-if="store.channelType==1">自营</span>
					<span class="store-tag-text tag-red" v-if="store.channelType==2">1688</span>
					<span class="store-tag-text tag-orange" v-if="store.channelType==3">淘宝</span>
					<span class="store-tag-text tag-red" v-if="store.channelType==4">京东</span>
					<span class="store-name">{{ store.merchantName }}</span>
				</div>

				<div class="product-item" v-for="(item, pIdx) in store.items" :key="pIdx">
					<el-image class="product-checkbox" :src="item.checked ? require('@/static/CodeBuddyAssets/30845_2685/16.svg') : require('@/static/CodeBuddyAssets/30845_2685/27.svg')" @click="cartChecked(item)"></el-image>
					<el-image class="product-img" :src="item.picUrl" :preview-src-list="[item.picUrl]" fit="cover"></el-image>
					<div class="product-info">
						<div class="product-name">{{ item.goodsName }}</div>
						<div class="product-spec-row">
							<span class="product-spec">{{ item.specifications.join(' ') }}</span>
							<!-- <el-image class="spec-edit-icon" :src="require('@/static/CodeBuddyAssets/30845_2685/13.svg')"></el-image> -->
						</div>
					</div>
					<div class="product-price-col">
						<span class="p-price-symbol">￥</span>
						<span class="p-price-value">{{ item.price }}</span>
					</div>
					<div class="product-qty">
						<div class="qty-control">
							<div class="qty-btn" @click="decreaseQty(sIdx, pIdx)">
								<el-image :src="require('@/static/CodeBuddyAssets/30845_2685/10.svg')"></el-image>
							</div>
							<div class="qty-value">{{ item.number }}</div>
							<div class="qty-btn" @click="increaseQty(sIdx, pIdx)">
								<el-image :src="require('@/static/CodeBuddyAssets/30845_2685/9.svg')"></el-image>
							</div>
						</div>
					</div>
					<el-image class="product-delete" :src="require('@/static/CodeBuddyAssets/30845_2685/18.svg')" @click="deleteItem(sIdx, pIdx)"></el-image>
				</div>
			</div>
		</div>

		<!-- ====== 底部结算栏 ====== -->
		<div class="car-bottom-bar">
			<div class="bottom-inner">
				<div class="bottom-left">
					<el-image class="bt-check-icon" :src="selAll ? require('@/static/CodeBuddyAssets/30845_2685/17.svg') : require('@/static/CodeBuddyAssets/30845_2685/48.svg')" @click="carSelAll"></el-image>
					<span class="bt-selected">全选</span>
				</div>
				<div class="bottom-right">
					<div class="bt-total">
						<span class="bt-total-label">合计</span>
						<span class="bt-total-price">
							<span class="bt-price-symbol">￥</span>
							<span class="bt-price-value">{{ totalPrice }}</span>
						</span>
					</div>
					<div class="bt-checkout-btn" @click="checkout">去结算&nbsp;({{ selectedCount }})</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
import newsPageHeader from '@/components/newsPageHeader.vue'
import {
	cartcount,
	cartlist,
	cartcartPrice,
	cartupdateNumber,
	cartdelete,
	cartcheck,
	cartcheckAll,
} from "/src/api/api.js"
export default {
	name: 'ShopCar',
	components: {
		newsPageHeader
	},
	data() {
		return {
			cartNub:0,
			selAll:false,
			totalPrice:120,
			selectedCount:1,
			carArr:[],
		}
	},
	mounted() {
		this.categoryAll()
	},
	methods: {
		// 我的购物车
		async categoryAll(){
			const res = await cartlist({goodsType:this.type*1})
			if(res.code==200){
				this.selectedCount = 0
				this.selAll = true
				res.data.forEach((item)=>{
					var storeAll = true
					item.items.forEach((itm)=>{
						itm.specificationsTxt = itm.specifications.join(',')
						if(!itm.checked){
							storeAll = false
						}else{
							this.selectedCount++
						}
					})
					item.storeAll = storeAll
					if(!storeAll){
						this.selAll = false
					}
				})
				this.carArr = res.data
				this.cartcountGet()
				this.cartcartPriceGet()
			}else{this.Tips(res.msg,'error');}
		},
		// 购物车数量
		async cartcountGet(){
			var res;
			res = await cartcount({});
			if(res.code==200){
				this.cartNub = res.data
			}else{this.Tips(res.msg,'error')}
		},
		// 购物车价格
		async cartcartPriceGet(){
			const res = await cartcartPrice({})
			if(res.code==200){
				this.totalPrice = res.data
			}else{this.Tips(res.msg,'error');}
		},
		// 购物车商品勾选状态
		async cartChecked(item){
			if(item.checked){item.checked = 0}else{item.checked = 1}
			var data = {
				cartId:item.id,
				checked:item.checked,
			}
			const res = await cartcheck(data)
			if(res.code==200){
				this.categoryAll()
			}else{this.Tips(res.msg,'error');}
		},
		// 全选
		async carSelAll(){
			if(this.selAll){this.selAll = false}else{this.selAll = true}
			const res = await cartcheckAll({checked:this.selAll?1:0})
			if(res.code==200){
				// this.Tips(res.msg);
				this.categoryAll()
			}else{this.Tips(res.msg,'error');}
		},
		// 选择店铺
		async selStore(storeAll,name){
			if(storeAll){storeAll = 0}else{storeAll = 1}
			const res = await cartcheckAll({checked:storeAll,merchantName:name})
			if(res.code==200){
				// this.Tips(res.msg);
				this.categoryAll()
			}else{this.Tips(res.msg,'error');}
		},
		decreaseQty(sIdx, pIdx) {
			const item = this.carArr[sIdx].items[pIdx]
			if (item.number > 1) item.number--
			this.cartUpdate(item)
		},
		increaseQty(sIdx, pIdx) {
			const item = this.carArr[sIdx].items[pIdx]
			item.number++
			this.cartUpdate(item)
		},
		// 购物车修改
		async cartUpdate(item){
			var data = {
				cartId:item.id,
				number:item.number,
			}
			const res = await cartupdateNumber(data)
			if(res.code==200){
				this.categoryAll()
			}else{this.Tips(res.msg,'error');}
		},
		deleteItem(sIdx, pIdx) {
			const item = this.carArr[sIdx].items[pIdx]
			this.cartRemove(item.id)
		},
		// 购物车商品删除
		async cartRemove(ids){
			const res = await cartdelete({ids:ids})
			if(res.code==200){
				this.Tips(res.msg);
				this.categoryAll()
			}else{this.Tips(res.msg,'error');}
		},
		// 跳转到结算页面
		checkout() {
			if(this.selectedCount){
				this.link('/shopOrder')
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.shop-car-page {
	width: 100%;
	min-height: 100vh;
	background: #F8F8F8;
	padding-bottom: 140px;
}

/* ===================================================================
   页面标题
   =================================================================== */
.page-title {
	display: flex;
	align-items: center;
	padding-top: 20px;
	margin-left: 396px;
}
.page-title-icon {
	width: 24px;
	height: 24px;
	margin-right: 8px;
}
.page-title-text {
	font-size: 26px;
	font-weight: 500;
	color: #0096FF;
	margin: 0;
}
.page-title-count {
	font-size: 16px;
	color: #333;
	margin-left: 4px;
	margin-top: 4px;
}

/* ===================================================================
   购物车主卡片
   =================================================================== */
.car-card {
	width: 1128px;
	margin: 16px auto 0;
	background: #fff;
	border-radius: 8px;
	padding: 0 24px 24px;
	box-sizing: border-box;
}

/* 工具栏 */
.car-toolbar {
	display: flex;
	align-items: center;
	// justify-content: space-between;
	padding: 18px 0 14px;
	border-bottom: 1px solid #EDEDED;
}
.toolbar-left {
	display: flex;
	align-items: center;
}
.tb-check-icon {
	width: 20px;
	height: 20px;
	cursor: pointer;
}
.tb-all-text {
	font-size: 14px;
	color: #333;
	margin-left: 8px;
	cursor: pointer;
}
.toolbar-right {
	display: flex;
	align-items: center;
	margin-left: 12px;
}
.tb-action-btn {
	display: flex;
	align-items: center;
	cursor: pointer;
	margin-right: 16px;
	font-size: 14px;
	color: #333;
}
.tb-action-btn:last-child {
	margin-right: 0;
}
.tb-action-icon {
	width: 20px;
	height: 20px;
	margin-right: 4px;
}
.tb-fav-btn {
	width: 60px;
	height: 32px;
	border: 1px solid #E9E9E9;
	border-radius: 4px;
	justify-content: center;
	box-sizing: border-box;
}

/* ===================================================================
   店铺分组
   =================================================================== */
.store-group {
	border: 1px solid #EDEDED;
	border-radius: 6px;
	margin-top: 16px;
	overflow: hidden;
}
.store-header {
	height: 39px;
	background: #FAFAFA;
	display: flex;
	align-items: center;
	padding: 0 24px;
}
.store-checkbox {
	width: 20px;
	height: 20px;
	cursor: pointer;
	margin-right: 8px;
}
.store-avatar {
	width: 18px;
	height: 18px;
	margin-right: 4px;
}
.store-tag-text {
	border-radius: 3px;
	font-size: 12px;
	font-weight: 400;
	padding: 0px 4px;
	display: inline-block;
	margin-right: 4px;
}
.tag-orange {
	border: 1px solid #FF7120;
	background: #FFF5E9;
	color: #FF7120;
}
.tag-red {
	border: 1px solid #FC3C3C;
	background: #FFE9E9;
	color: #FC3C3C;
}
.tag-blue {
	border: 1px solid #0096FF;
	background: #E9F5FF;
	color: #0096FF;
}

.store-name {
	font-size: 14px;
	font-weight: 500;
	color: #333;
}

/* 商品行 */
.product-item {
	display: flex;
	align-items: center;
	padding: 16px 24px;
	border-top: 1px solid #F5F5F5;
	position: relative;
}
.product-item:first-of-type {
	border-top: none;
}
.product-checkbox {
	width: 20px;
	height: 20px;
	cursor: pointer;
	margin-right: 16px;
	flex-shrink: 0;
}
.product-img {
	width: 68px;
	height: 68px;
	border-radius: 6px;
	flex-shrink: 0;
	cursor: pointer;
}
.product-info {
	flex: 1;
	margin-left: 12px;
	min-width: 0;
}
.product-name {
	font-size: 14px;
	font-weight: 500;
	color: #333;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.product-spec-row {
	display: flex;
	align-items: center;
	margin-top: 6px;
}
.product-spec {
	font-size: 14px;
	color: #7A7A7A;
}
.spec-edit-icon {
	width: 14px;
	height: 14px;
	margin-left: 4px;
	cursor: pointer;
}

.product-price-col {
	color: #FC3C3C;
	margin-left: 20px;
	width: 80px;
	text-align: right;
	flex-shrink: 0;
}
.p-price-symbol {
	font-size: 12px;
	font-weight: 500;
	font-family: 'MiSans', sans-serif;
}
.p-price-value {
	font-size: 20px;
	font-weight: 600;
	font-family: 'MiSans', sans-serif;
}

.product-qty {
	margin-left: 24px;
	flex-shrink: 0;
}
.qty-control {
	width: 112px;
	height: 32px;
	border: 1px solid #DADDE0;
	border-radius: 4px;
	display: flex;
	align-items: center;
	overflow: hidden;
}
.qty-btn {
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	flex-shrink: 0;
}
.qty-btn .el-image {
	width: 14px;
	height: 14px;
}
.qty-value {
	width: 48px;
	height: 32px;
	text-align: center;
	line-height: 32px;
	font-size: 14px;
	color: #333;
	border-left: 1px solid #DADDE0;
	border-right: 1px solid #DADDE0;
	flex-shrink: 0;
}

.product-delete {
	width: 18px;
	height: 18px;
	margin-left: 16px;
	cursor: pointer;
	flex-shrink: 0;
}

/* ===================================================================
   底部结算栏
   =================================================================== */
.car-bottom-bar {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 80px;
	background: #fff;
	z-index: 100;
}
.bottom-inner {
	width: 1128px;
	height: 100%;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.bottom-left {
	display: flex;
	align-items: center;
}
.bt-check-icon {
	width: 20px;
	height: 20px;
	cursor: pointer;
}
.bt-selected {
	font-size: 14px;
	color: #333;
	margin-left: 8px;
}
.bottom-right {
	display: flex;
	align-items: center;
}
.bt-total {
	display: flex;
	align-items: baseline;
	margin-right: 24px;
}
.bt-total-label {
	font-size: 14px;
	font-weight: 500;
	color: #333;
	margin-right: 4px;
}
.bt-total-price {
	color: #FC3C3C;
}
.bt-price-symbol {
	font-size: 12px;
	font-weight: 500;
	font-family: 'MiSans', sans-serif;
}
.bt-price-value {
	font-size: 20px;
	font-weight: 600;
	font-family: 'MiSans', sans-serif;
}
.bt-checkout-btn {
	width: 136px;
	height: 50px;
	background: #0096FF;
	border-radius: 6px;
	color: #fff;
	font-size: 16px;
	text-align: center;
	line-height: 50px;
	cursor: pointer;
	transition: background 0.3s;
}
.bt-checkout-btn:hover {
	background: #33ABFF;
}
</style>
